import { Divider, MenuItem } from "@mui/material";
import { ContentCopy as ContentCopyIcon, Edit as EditIcon, Delete as DeleteIcon, MoveDown as MoveDownIcon, ViewWeek as ViewWeekIcon } from "@mui/icons-material";
import Add from "./Add";
import Edit from "./Edit";
import Remove from "./Remove";
import Move from "./Move";
import Copy from "./Copy";
import AddBulk from "./AddBulk";
import Columns from "./Columns";

export function ActionsDialogPage({ open, close, menu, category, instance, reportAction }) {
  return (<>
    <Add
      open={open === 1}
      close={close}
      menu={menu}
      category={category}
      reportAction={reportAction} />
    <Edit
      open={open === 2}
      close={close}
      menu={menu}
      category={category}
      instance={instance}
      reportAction={reportAction} />
    <Remove
      open={open === 3}
      close={close}
      category={category}
      instance={instance}
      reportAction={reportAction} />
    <Move
      open={open === 4}
      close={close}
      menu={menu}
      category={category}
      instanceSelected={instance}
      reportAction={reportAction} />
    <Copy
      open={open === 5}
      close={close}
      menu={menu}
      instanceSelected={instance}
      reportAction={reportAction} />
    <AddBulk
      open={open === 6}
      close={close}
      menu={menu}
      category={category}
      reportAction={reportAction} />
    <Columns
      open={open === 7}
      close={close}
      menu={menu}
      category={category}
      instance={instance}
      reportAction={reportAction} />
  </>)
}

export function ActionsMenuPage({ t, action, conditionsToShow }) {
  // 2: edit, 3: delete
  return (<>
    <MenuItem onClick={() => { action(2) }} disableRipple>
      <EditIcon /> {t('button_text_edit')}
    </MenuItem>
    <MenuItem onClick={() => { action(5) }} disableRipple>
      <ContentCopyIcon /> {t('button_text_copy')}
    </MenuItem>
    <MenuItem onClick={() => { action(4) }} disableRipple>
      <MoveDownIcon /> {t('button_text_move')}
    </MenuItem>
    {conditionsToShow[7] ?
    <MenuItem onClick={() => { action(7) }} disableRipple>
      <ViewWeekIcon /> {t('button_text_columns')}
    </MenuItem>
    : null}
    <Divider sx={{ my: 0.5 }} />
    <MenuItem onClick={() => { action(3) }} disableRipple>
      <DeleteIcon color="error" /> {t('button_text_delete')}
    </MenuItem>
  </>)
}